import React from 'react';
import { Box, Button, Stack, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import FormBuilder from '../FormBuilder';

/**
 * Full-height Form Builder under Studio, sharing the main app shell (nav + app bar).
 */
export default function StudioFormsDesignPage({ darkMode }) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        flex: '1 1 auto',
        alignSelf: 'stretch',
        minHeight: { xs: 'calc(100dvh - 56px)', sm: 'calc(100dvh - 64px)' },
        height: { xs: 'calc(100dvh - 56px)', sm: 'calc(100dvh - 64px)' },
        overflow: 'hidden',
      }}
    >
      <Stack
        direction="row"
        alignItems="center"
        spacing={1}
        sx={{
          flexShrink: 0,
          px: 2,
          py: 1,
          borderBottom: 1,
          borderColor: 'divider',
          bgcolor: 'background.paper',
        }}
      >
        <Button component={RouterLink} to="/studio/forms" size="small" sx={{ textTransform: 'none' }}>
          ← Forms
        </Button>
        <Button component={RouterLink} to="/studio" size="small" color="inherit" sx={{ textTransform: 'none' }}>
          Studio
        </Button>
        <Typography variant="body2" color="text.secondary" sx={{ flex: 1, minWidth: 0 }} noWrap>
          Form designer
        </Typography>
      </Stack>
      <Box sx={{ flex: 1, minHeight: 0, overflow: 'hidden' }}>
        <FormBuilder darkMode={darkMode} embedded />
      </Box>
    </Box>
  );
}
